import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DragScrollModule } from 'ngx-drag-scroll';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BuyFunctionalityComponent } from './cinejoy/common/buy-functionality/buy-functionality.component';
import { CartFunctionalityComponent } from './cinejoy/common/cart-functionality/cart-functionality.component';
import { MyTicketsComponent } from './cinejoy/common/my-tickets/my-tickets.component';
import { PromoCodePopupComponent } from './cinejoy/common/promo-code-popup/promo-code-popup.component';
import { LoadingSpinnerComponent } from './cinejoy/common/purchase-flow/loading-spinner/loading-spinner.component';
import { PurchaseFlowComponent } from './cinejoy/common/purchase-flow/purchase-flow.component';
import { ShoppingCartComponent } from './cinejoy/common/shopping-cart/shopping-cart.component';
import { SidebarComponent } from './cinejoy/common/sidebar/sidebar.component';
import { EmojiChartComponent } from './cinejoy/spotlight/emoji-chart/emoji-chart.component';
import { MobilePremiereEventAgendaComponent } from './cinejoy/spotlight/mobile-premiere-event-agenda/mobile-premiere-event-agenda.component';
import { MobilePremiereFeaturedGuestComponent } from './cinejoy/spotlight/mobile-premiere-featured-guest/mobile-premiere-featured-guest.component';
import { NotificationBadgeComponent } from './cinejoy/spotlight/notification-badge/notification-badge.component';
import { PaymentFunctionalityComponent } from './cinejoy/spotlight/payment-functionality/payment-functionality.component';
import { PremiereEventAgendaComponent } from './cinejoy/spotlight/premiere-event-agenda/premiere-event-agenda.component';
import { PremiereFeatureGuestComponent } from './cinejoy/spotlight/premiere-feature-guest/premiere-feature-guest.component';
import { RedCarpetChatbarComponent } from './cinejoy/spotlight/red-carpet-chatbar/red-carpet-chatbar.component';
import { SpotlightFullPageLoaderComponent } from './cinejoy/spotlight/spotlight-full-page-loader/spotlight-full-page-loader.component';
import { SafePipePipe } from './safe-pipe.pipe';
import { VideoPlayerComponent } from './cinejoy/spotlight/video-player/video-player.component';
import { CinejoyFooterComponent } from './cinejoy/common/cinejoy-footer/cinejoy-footer.component';
import { WebNavbarComponent } from './cinejoy/common/navbar/web-navbar/web-navbar.component';
import { CinejoyMobileFooterComponent } from './cinejoy/common/cinejoy-mobile-footer/cinejoy-mobile-footer.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { HeaderComponent } from './creatics/common/header/header.component';
import { FooterComponent } from './creatics/common/footer/footer.component';
import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { MatExpansionModule } from '@angular/material/expansion';
import { CountdownPipe } from './timer.pipe';
import { MatIconModule } from '@angular/material/icon';
import { TruncatePipe } from '../core/Pipe/truncate.pipe';

@NgModule({
  declarations: [
    SidebarComponent,
    ShoppingCartComponent,
    EmojiChartComponent,
    RedCarpetChatbarComponent,
    SpotlightFullPageLoaderComponent,
    PremiereEventAgendaComponent,
    BuyFunctionalityComponent,
    PremiereFeatureGuestComponent,
    PurchaseFlowComponent,
    MobilePremiereEventAgendaComponent,
    LoadingSpinnerComponent,
    MobilePremiereFeaturedGuestComponent,
    CartFunctionalityComponent,
    PaymentFunctionalityComponent,
    SafePipePipe,
    PromoCodePopupComponent,
    MyTicketsComponent,
    NotificationBadgeComponent,
    VideoPlayerComponent,
    CinejoyFooterComponent,
    WebNavbarComponent,
    CinejoyMobileFooterComponent,
    HeaderComponent,
    FooterComponent,
    CountdownPipe,
    TruncatePipe
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    FlexLayoutModule,
    LayoutModule,
    DragScrollModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatChipsModule,
    NgDynamicBreadcrumbModule,
    MatIconModule
  ],
  exports: [
    SidebarComponent,
    ShoppingCartComponent,
    EmojiChartComponent,
    RedCarpetChatbarComponent,
    SpotlightFullPageLoaderComponent,
    PremiereEventAgendaComponent,
    PremiereFeatureGuestComponent,
    MobilePremiereEventAgendaComponent,
    MobilePremiereFeaturedGuestComponent,
    BuyFunctionalityComponent,
    PurchaseFlowComponent,
    LoadingSpinnerComponent,
    CartFunctionalityComponent,
    PaymentFunctionalityComponent,
    SafePipePipe,
    PromoCodePopupComponent,
    NotificationBadgeComponent,
    VideoPlayerComponent,
    WebNavbarComponent,
    CinejoyFooterComponent,
    CinejoyMobileFooterComponent,
    HeaderComponent,
    FooterComponent,
    CdkAccordionModule,
    MatExpansionModule,
    CountdownPipe,
    TruncatePipe
  ]
})
export class SharedModule { }
